export default "__VITE_ASSET__BqlAFBdO__"